import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {

    "AgreementsListTile": () => import("./components/tiles/AgreementsListTile.vue"),                       //Component containing the list of contracts
    "AgreementsStepperTile": () => import("./components/tiles/AgreementsStepperTile.vue"),                 //Component containing the stepper needed to create a new contract
    "NewAgreementsSingleTileContainer": () => import("./components/NewAgreementsSingleTileContainer.vue"), //Container component of the module tiles
    "NewAgreementsListTileContainer": () => import("./components/NewAgreementsListTileContainer.vue"), //Container component of the list tile
    "IndexContentTile": () => import("./components/detail/IndexContentTile.vue"),                          //Component containing detail custom panels
    "AgreementEditMainDataTile": () => import("./components/detail/AgreementEditMainDataTile.vue"),               //Component containing main data step for editing contract main data
    "AgreementEditPartiesTile": () => import("./components/detail/AgreementEditPartiesTile.vue"),               //Component containing parties step for editing contract parties

};

export default globals;
